var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-left":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.userProfile.showWellcomeMessage)?_c('v-flex',{attrs:{"d-flex":""}},[_c('welcome-message')],1):_vm._e(),_c('v-flex',{attrs:{"d-flex":""}},[_c('message-list',{attrs:{"visibilityMode":"all"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }